<script>
  export default {
    data() {
      return {
        defaultMaxRowsPerCsv: 10000,
      };
    },
    methods: {
      async searchReports(query) {
        try {
          const response = await this.$api.post('reports', query);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error generating the report');
          return null;
        }
      },
      async loadCsvExportLimit() {
        try {
          const response = await this.$api.get(`reports/csv-row-limit`);
          return response.data;
        } catch (error) {
          return this.defaultMaxRowsPerCsv;
        }
      },
    }
  };
</script>
